import { Component } from '@opten/compiler/metadata/component';
import removeClass from '@opten/dom/remove-class';
import { filter } from 'rxjs/operators';
import { CurrencyConverter } from '../../utilities/currency.converter';
import { shopService } from './shop-context';

@Component({ className: 'js-product-detail', observe: true })
export class ProductDetail {
	currencyConverter: CurrencyConverter;

	constructor(private element: HTMLElement) {
		this.currencyConverter = new CurrencyConverter();

		const isPromotionPackage = this.element.hasAttribute('data-is-promotion-package');

		if (isPromotionPackage) {
			this.renderPrice(this.element, true);
		} else {
			const variants = Array.from(element.querySelectorAll('.js-product-detail-variant'));
			if (variants && variants.length > 0) {
				variants.forEach(variant => this.renderPrice(variant as HTMLElement));
			} else {
				this.renderPrice(this.element);
			}
		}
	}

	private renderPrice(variant: HTMLElement, isPromotionPackage = false) {
		const uomId = variant.getAttribute('data-amount-uom-id');
		const articleNumber = variant.getAttribute('data-article-number');
		const pricePrefix = variant.getAttribute('data-price-prefix');

		let priceElement = Array.from(variant.querySelectorAll('.js-variant-price')) as HTMLElement[];
		if (!priceElement || priceElement.length === 0) {
			priceElement = [variant];
		}

		const quantityEl = variant.querySelector('.js-product__quantity') as HTMLInputElement;
		let quantity = 1;
		if (quantityEl && +quantityEl.value > 0) {
			quantity = +quantityEl.value;
		}

		shopService
			.getPrice(articleNumber, quantity, uomId, null, isPromotionPackage)
			.pipe(filter(price => !!price))
			.subscribe(price => {
				priceElement.forEach(o => (o.innerHTML = ''));

				if (price.promotionPrice > 0) {
					const basePrice = document.createElement('span');
					basePrice.className = 'c-variant__price__base';

					const promotionPrice = document.createElement('span');
					promotionPrice.className = 'c-variant__price__promotion';

					this.currencyConverter.apply(basePrice, price.price);

					const value = this.currencyConverter.getFormattedString(price.promotionPrice);
					if (!pricePrefix) {
						promotionPrice.innerText = value;
					}

					const salesBadge = this.element.parentElement.querySelector('.js-product-detail-sale');
					if (salesBadge) {
						removeClass(salesBadge, 'd-none');
					}

					priceElement.forEach(o => o.appendChild(basePrice.cloneNode(true)));
					priceElement.forEach(o => o.appendChild(promotionPrice.cloneNode(true)));
				} else {
					// this.currencyConverter.apply(priceElement, price.price);
					let value = this.currencyConverter.getFormattedString(price.price);
					if (pricePrefix) {
						value = pricePrefix.replace('{price}', value);
					}
					priceElement.forEach(o => (o.innerText = `${value}`));
				}

				const counter = variant.querySelector('.js-input-counter');
				if (counter) {
					removeClass(counter, 'is-disabled');
					counter.querySelector('input').disabled = false;
				}
			});
	}
}
